<template>
    <!-- 升学途径 其他升学途径 -->
    <!--  (中外合作)-->
    <div class="gangao_recruitstudents studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">什么是中外合作办学？</h6>
            <div class="main_box">
                <p>中外合作办学通常是指外国教育机构同中国教育机构在中国境内合作举办的以中国公民为主要招生对象的教育机构，目前所称的中外合作办学一般是指国家鼓励的在高等教育、职业教育领域开展的中外合作办学。中外合作办学有合作设立机构和合作举办项目两种形式。</p>
                <p>如宁波诺丁汉大学是由国内的浙江万里学院以及英国的诺丁汉大学合办的一所院校，为合作设计机构类型。</p>
                <p>中央财经大学国际经济与贸易（中外合作）则是央财与与澳大利亚维多利亚大学合作的本科教育项目，为合作举办项目形式。</p>
            </div>    
        </div>
        <div class="main">
            <h6 class="main_title">关于学历、学位证书？</h6>
            <div class="main_box">
                <p>目前，我国只有获得国务院教育行政部门统一编号、统一格式的中外合作办学许可证或者中外合作办学项目批准书的中外合作办学机构和项目可以依法颁发外国教育机构的学历、学位证书。</p>
                <p>颁发外国教育机构的学历、学位证书应当符合的条件和规定有：</p>
                <p>(一)中外合作办学机构和项目应当依法设立和举办;</p>
                <p>(二)中方合作办学者应当是实施相应层次和类别学历教育的中国教育机构;</p>
                <p>(三)外国教育机构的学历、学位证书其课程设置、教学内容不得低于外国教育机构在其所属国的标准和要求;</p>
                <p>(四)颁发的外国教育机构的学历、学位证书应当与其在所属国颁发的证书相同，并在该国获得承认。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">办学机构和项目的合法性</h6>
            <p>目前根据《中外合作办学条例》新批准的本科以上中外合作办学机构和项目以及根据《中外合作办学条例》完成复审的部分省市中外合作办学机构与项目已经教育部网站、教育部教育涉外监管信息网公布。 网址为：www.jsj.edu.cn</p>
        </div>
        <div class="remind main">
            <h6 class="main_title">特别提醒</h6>
            <div class="main_box">
                <p><span>1</span>中外合作办学多引进国外教育模式，使用原版教材，采取外教授课等。但中外合作办学情况比较复杂，招生机构的水平更是参差不齐。报考时需谨慎。</p>
                <p><span>2</span>中国教育机构没有实质性引进外国教育资源，仅以互认学分的方式与外国教育机构开展的教育教学活动，例如一般的校际交流项目、外国大学预科班、双联学位、双语授课项目、引进外国高校部分课程等，均不属于中外合作办学的范畴。</p>
                <p><span>3</span>要辨清项目属于“计划内”还是“计划外”。计划内招生是纳入国家普通高校招生计划的统招生。考生必须填报高考志愿，并参加高考录取，毕业后分别获得中外双方学校颁发的文凭。</p>
                <p><span>4</span>计划外招生是学校采取自主招生方式招收的学生。学生无须填报高考志愿，只参加学校自己举办的入学考试即可(一般会参考高考成绩及英语单科成绩)。先在中方学校修得相应学分，通过语言考试后再被合作学校录取，毕业后获得外方学校颁发的文凭。一般情况下，“计划内招生”的中外合作办学项目质量是有保证的，有些中外合作办学项目同时具有计划内和计划外两种招生形式。</p>
                <p>可通过所在省当年下发的“招生专业目录”查看是否为计划内招生。全部高考统招计划都在其中，计划内的中外合作办学项目也包括在内。</p>
            </div>   
        </div>

        <div class="universities main">
            <h6 class="main_title">
                招生院校信息 
                <span>*由于各方面条件不断调整变化，请考生以各省考试院公布的最新消息为主</span>
            </h6>
            <div class="school_box" v-for="(item, index) in universities" :key="index">
                <p class="school_title">{{item.province}}</p>
                <ul>
                    <li  v-for="(school, index) in item.school" :key="index" @click="goUniversity(school)">{{school}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [
                { province: '安徽', school: ["黄山学院","巢湖学院","合肥师范学院","安徽建筑大学","安徽工程大学","合肥工业大学","合肥学院","安徽大学","安徽科技学院"] },
                { province: '北京', school: ["北京航空航天大学","北京邮电大学世纪学院","中国农业大学","北京理工大学","北京建筑大学","华北科技学院","对外经济贸易大学","北京外国语大学","北京林业大学","华北电力大学","首都医科大学","中国人民大学","北京工业大学","北京工商大学","北京联合大学","北京邮电大学","北京交通大学","中央财经大学","中国传媒大学","北京化工大学","北京农学院"] },
                { province: '福建', school: ["福建农林大学","集美大学","厦门大学","福建师范大学","三明学院","厦门理工学院","福州大学","福建农林大学金山学院","莆田学院"] },
                { province: '广东', school: ["北京师范大学—香港浸会大学联合国际学院","汕头大学","华南师范大学","广东工业大学","华南师范大学增城学院","北京师范大学珠海分校","中山大学","广州大学","广东技术师范学院","华南农业大学","华南理工大学广州学院","北京理工大学珠海学院","香港中文大学(深圳)","暨南大学"] },
                { province: '广西', school: ["广西中医药大学","广西师范大学","广西财经学院","广西师范学院","广西大学","广西艺术学院","钦州学院","广西医科大学","桂林理工大学","广西民族大学","桂林电子科技大学","广西科技大学","桂林旅游学院"] },
                { province: '贵州', school: ["贵州财经大学","贵州民族大学"] },
                { province: '海南', school: ["海南热带海洋学院","海南大学","三亚学院"] },
                { province: '河北', school: ["河北工业大学","河北科技师范学院","河北大学","河北医科大学","河北金融学院","华北理工大学","河北师范大学","河北科技大学","河北经贸大学","河北农业大学","河北外国语学院","燕山大学","石家庄铁道大学","石家庄经济学院","北华航天工业学院"] },
                { province: '河南', school: ["郑州大学","华北水利水电大学","洛阳理工学院","河南财经政法大学","河南师范大学","河南农业大学","河南大学","南阳师范学院","河南城建学院","许昌学院","河南工程学院","河南理工大学","河南科技大学","华北水利水电学院","郑州航空工业管理学院","安阳工学院","信阳师范学院","黄淮学院","河南工业大学","中原工学院","郑州轻工业学院","新乡医学院","商丘师范学院","南阳理工学院","黄河科技学院"] },
                { province: '黑龙江', school: ["哈尔滨工程大学","东北林业大学","绥化学院","黑龙江中医药大学","东北农业大学","东北石油大学","黑龙江大学","哈尔滨学院","东北农业大学成栋学院","齐齐哈尔医学院","大庆师范学院","黑河学院","哈尔滨师范大学","黑龙江科技大学","黑龙江东方学院","黑龙江工程学院","哈尔滨医科大学","黑龙江八一农垦大学","哈尔滨理工大学","哈尔滨金融学院","哈尔滨工业大学","哈尔滨体育学院","牡丹江医学院","牡丹江师范学院","齐齐哈尔大学","佳木斯大学","哈尔滨商业大学","黑龙江外国语学院"] },
                { province: '湖北', school: ["武汉纺织大学","湖北大学","湖北美术学院","湖北工程学院","武昌理工学院","江汉大学","武汉理工大学","华中师范大学","长江大学","湖北理工学院","武汉东湖学院","中国地质大学(武汉)","湖北中医药大学","黄冈师范学院","湖北经济学院","湖北师范学院","湖北第二师范学院","武汉体育学院","三峡大学","武汉科技大学","汉口学院","湖北科技学院","湖北民族学院","湖北工业大学","中南财经政法大学","武汉商学院"] },
                { province: '湖南', school: ["湖南商学院","湖南工业大学","湖南城市学院","湖南农业大学","湘潭大学","中南大学","湖南财政经济学院","湖南涉外经济学院","湖南工学院","湖南工程学院","邵阳学院","吉首大学","湖南人文科技学院","长沙理工大学","中南林业科技大学","南华大学","湖南文理学院","湘南学院","湖南师范大学","湖南科技大学"] },
                { province: '吉林', school: ["吉林大学","长春师范大学","吉林建筑大学","吉林华桥外国语学院","吉林农业大学","吉林工程技术师范学院","延边大学","东北电力大学","吉林师范大学","吉林化工学院","东北师范大学人文学院","通化师范学院","东北师范大学","长春大学","长春理工大学","吉林农业科技学院","白城师范学院","北华大学","吉林财经大学","长春工程学院","长春科技学院","长春工业大学"] },
                { province: '江苏', school: ["西交利物浦大学","苏州大学应用技术学院","中国矿业大学（徐州）","盐城工学院","常州大学","苏州科技学院","河海大学","盐城师范学院","南京林业大学","金陵科技学院","南京工程学院","江南大学","三江学院","苏州高博软件技术职业学院","江苏大学","南京大学","江苏理工学院","昆山杜克大学","徐州工程学院","南京工业大学浦江学院","苏州科技大学","南京航空航天大学","扬州大学","南京理工大学","南京邮电大学通达学院","南京艺术学院","南京邮电大学","江苏科技大学","南京审计大学","南京信息工程大学","淮阴师范学院","无锡太湖学院","南京财经大学","南京中医药大学","常熟理工学院","江苏师范大学","苏州大学文正学院","苏州大学","南京晓庄学院","南京师范大学","常州工学院","南京工业大学","中国药科大学"] },
                { province: '江西', school: ["江西科技师范大学","江西财经大学","赣南师范大学","东华理工大学","华东交通大学","南昌大学","井冈山大学","南昌理工学院","江西中医药大学","南昌航空大学","南昌工程学院"] },
                { province: '辽宁', school: ["东北大学","沈阳师范大学","中国医科大学","沈阳建筑大学","鲁迅美术学院","大连科技学院","辽宁大学","东北财经大学","沈阳工业大学","鞍山师范学院","沈阳大学","沈阳城市建设学院","辽宁师范大学","大连理工大学","大连交通大学","大连工业大学","大连大学","沈阳航空航天大学","辽宁石油化工大学","大连海洋大学","沈阳工程学院"] },
                { province: '内蒙古', school: ["内蒙古民族大学","内蒙古师范大学","内蒙古财经大学","内蒙古工业大学","内蒙古农业大学","内蒙古科技大学","呼伦贝尔学院"] },
                { province: '山东', school: ["山东工商学院","济南大学","山东师范大学","哈尔滨工业大学(威海)","烟台大学文经学院","临沂大学","青岛科技大学","泰山医学院","山东理工大学","齐鲁工业大学","山东科技大学","青岛理工大学","山东农业大学","山东建筑大学","山东交通学院","济宁医学院","滨州学院","山东财经大学","鲁东大学","烟台大学","山东大学","中国海洋大学","聊城大学","山东艺术学院","青岛大学"] },
                { province: '山西', school: ["山西农业大学","山西财经大学","太原理工大学","太原科技大学"] },
                { province: '陕西', school: ["渭南师范学院","西安科技大学","榆林学院","西安邮电大学","西北工业大学","西安交通大学","西安电子科技大学","西安航空学院","西北农林科技大学","西北大学","西北民族大学"] },
                { province: '上海', school: ["同济大学","上海纽约大学","上海海事大学","上海海洋大学","华东政法大学","上海杉达学院","上海大学","东华大学","复旦大学","上海中医药大学","上海对外经贸大学","上海外国语大学","上海理工大学","上海工程技术大学","华东理工大学","上海电力学院","上海电机学院","上海师范大学天华学院","上海交通大学","上海师范大学","上海财经大学","上海应用技术学院","上海音乐学院","上海建桥学院","上海大学(悉尼工商学院)"] },
                { province: '天津', school: ["中国民航大学","天津商业大学","天津理工大学","天津科技大学","天津师范大学","南开大学","天津工业大学","天津美术学院","天津城建大学","天津大学","天津中医药大学","天津财经大学珠江学院","天津财经大学","天津职业技术师范大学"] },
                { province: '新疆', school: ["新疆农业大学"] },
                { province: '云南', school: ["云南财经大学","云南师范大学","云南农业大学","云南大学"] },
                { province: '浙江', school: ["宁波诺丁汉大学","浙江科技学院","温州肯恩大学","浙江大学","浙江工业大学","浙江理工大学","浙江大学城市学院","浙江大学宁波理工学院","宁波大学","温州医科大学","浙江农林大学","温州大学","中国计量大学","宁波工程学院","杭州电子科技大学","浙江师范大学","浙江财经大学","温州大学瓯江学院","浙江工业大学之江学院","浙江传媒学院","浙江海洋学院","丽水学院","宁波大红鹰学院"] },
                { province: '重庆', school: ["重庆工商大学","重庆大学","西南大学","四川外国语大学","重庆交通大学","重庆邮电大学","西南政法大学","重庆邮电大学移通学院","重庆理工大学","重庆第二师范学院"] },
                { province: '四川', school: ["四川师范大学","四川大学","西南交通大学","电子科技大学","四川农业大学","成都学院","成都理工大学","西南财经大学"] },
            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: '院校详情',
                query: {
                    id: id,
                }
            })
            window.open(href, '_blank');
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .free_medical_students {
        .universities {
        	ul {
	            li {
	                &:nth-child(8n-1),&:nth-child(8n-2),&:nth-child(8n-3),&:nth-child(8n) {
	                    background-color: #e6f8ff;
	                }
	            }
	        }
        }
    }
</style>